import React from 'react';
import { map } from 'lodash';
import ReactHighlightWords from 'react-highlight-words';
import {
  getSecondaryColorNumbers,
  extractHashtagsFromText,
} from '@wix/communities-blog-client-common';
import { shouldSearchByHashtag } from '../../../common/services/search-utils';
import styles from './highlighter.scss';

const STYLE = {
  backgroundColor: `rgba(${getSecondaryColorNumbers()}, 0.3)`,
};

const getWords = (query: string) =>
  shouldSearchByHashtag(query)
    ? map(extractHashtagsFromText(query), (hashtag) => `#${hashtag}`)
    : query.split(' ');

type Props = {
  text?: string;
  query: string;
};

const Highlighter = ({ text, query }: Props) => (
  <ReactHighlightWords
    highlightClassName={styles.mark}
    highlightStyle={STYLE}
    textToHighlight={text ?? ''}
    searchWords={getWords(query)}
  />
);

export default Highlighter;
